import React from 'react'

import builderStates from '../constants/builder-states'
import BasicLgyInputField from 'app/components/util/lgy-input-field/BasicLgyInputField'
import BasicLgySelectField from 'app/components/util/lgy-select-field/BasicLgySelectField'
import LgyLink from 'app/components/util/lgy-link/LgyLink'

import '../style/mini-condo-builder.scss'

export const MiniCondoBuilderForm = ({ whichReport, handleSubmit, handleChange, handleInvalid, name, stateCode, report, errors }) =>
  <div className='mini-condo-builder-form'>
    <h3>{whichReport} Report</h3>
    <form onSubmit={handleSubmit}>
      <legend className='usa-sr-only'>Request a Customized {whichReport} Report</legend>
      <div className='instructions'>Maximize for more search options</div>
      {report.list && report.list.length < 1 &&
        <div className='usa-input-error-message'>No results found with this search criteria.</div>}
      <BasicLgyInputField label='Name' type='text' id={`${whichReport}-name`} name='name' maxLength='100' value={name} onChange={handleChange} />
      <BasicLgySelectField label='State' id={`${whichReport}-stateCode`} name='stateCode' value={stateCode} onChange={handleChange}
        required onInvalid={handleInvalid} error={errors.stateCode ? errors.stateCode : undefined}>
        {builderStates.map(state => <option key={state.cd} value={state.cd}>{state.label}</option>)}
      </BasicLgySelectField>
      <button type='submit'>Submit</button>
    </form>
  </div>

export const MiniCondoBuilderResults = ({ whichReport, list, handleNewSearch }) =>
  <div className='mini-condo-builder-result'>
    <h3>{whichReport} Report Results</h3>
    <span>Viewing {list.length >= 10 ? '10' : list.length} of {list.length} records</span>
    <br />
    <LgyLink to={`/lgyhub/${whichReport === 'Condo' ? 'condo-report' : 'home-builders'}`}>See more information</LgyLink>
    <br />
    <LgyLink to='#' onClick={handleNewSearch}>New search</LgyLink>
    <hr />
    {whichReport === 'Condo' && list.slice(0, 9).map(condo =>
      <div className='mini-condo-builder-display' key={condo.id}>{condo.firstLineName} ({condo.developmentBusinessId})</div>)}
    {whichReport === 'Builder' && list.slice(0, 9).map(builder =>
      <div className='mini-condo-builder-display' key={builder.builderBuisnessId}>{builder.builderFirmName} ({builder.builderBuisnessId})</div>)}
  </div>
